import { render, staticRenderFns } from "./PdfViewerControls.vue?vue&type=template&id=6651878f&"
import script from "./PdfViewerControls.vue?vue&type=script&lang=js&"
export * from "./PdfViewerControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports